import { ImageBanner } from "@comparaonline/ui-promotions-image-banner";
import { MessageBanner } from "@comparaonline/ui-promotions-message-banner";
import { VideoBanner } from "@comparaonline/ui-promotions-video-banner";
import React from "react";
import { isVideo } from "./helper";

import { useBannerConfig } from "../../Header/hooks";

export const Banner: React.FC = () => {
  const bannerConfig = useBannerConfig();
  if (!bannerConfig) {
    return null;
  }

  const { variant, config } = bannerConfig;

  const areVideos = isVideo(config.srcLarge) && isVideo(config.srcSmall);
  const isImage = "image" === variant && !isVideo(config.srcLarge) && !isVideo(config.srcSmall);

  if (areVideos) {
    return <VideoBanner {...config} />;
  }
  if (isImage) {
    return <ImageBanner {...config} />;
  }
  return <MessageBanner {...config} />;
};
